export const classes = {
  list: 'flex flex-wrap mt-2',
};
